import React from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import FeaturedIn from "../components/FeaturedIn";
import CoursesSection from "../components/CoursesSection";
import TopicsSection from "../components/TopicsSection";
import FeaturesSection from "../components/FeaturesSection";
import TestimonialsSection from "../components/TestimonialsSection";
import FinalCTASection from "../components/FinalCTASection";
import Footer from "../components/Footer";

import AhaMomentAIHero from "../components/AhaMomentAIHero";

import "../styles/homepage.css";


const HomePage = () => {
  return (
    <>
      <Header />
      <main>
      <AhaMomentAIHero />
      {/* <HeroSection /> */}
        <TopicsSection />  {/* Understand Every Topic With AI */}
        <FeaturesSection />     {/* Built To Help You Learn Faster */} 
        <FeaturedIn />
        <CoursesSection /> {/* Courses Section */}
        <TestimonialsSection />
        <FinalCTASection />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;
